import { render, staticRenderFns } from "./RemoveShareCalendar.vue?vue&type=template&id=461539c0&"
import script from "./RemoveShareCalendar.vue?vue&type=script&lang=js&"
export * from "./RemoveShareCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports